import {Injectable} from "@angular/core";
import {User} from "src/app/auth/auth.model";
import {UsersApiService} from "../../api/users-api.service";
import {MessageService} from "../../utils/message/message.service";

@Injectable()
export class UserSuperAdminService {

  constructor(
    private usersApi: UsersApiService,
    private message: MessageService
  ) {
  }

  delete(user: User) {
    if (user.id != null) {
      return this.usersApi.delete(user);
    }
  }

  saveUpdate(user: User) {
    let edit = false;
    if (user.id != null) {
      edit = true;
    }

    if (edit) {
      return this.usersApi.update(user);
    } else {
      return this.usersApi.save(user);
    }
  }
}
